/**
 * date-fns Locale Helper
 *
 * Maps the i18next language code to the corresponding date-fns locale.
 * Used by all date-fns format() and formatDistanceToNow() calls to ensure
 * localized output for day names, month names, and relative times.
 */

import { Locale } from 'date-fns';
import { ca } from 'date-fns/locale/ca';
import { es } from 'date-fns/locale/es';
import { enUS } from 'date-fns/locale/en-US';

export type SupportedLanguage = 'ca' | 'es' | 'en';

const localeMap: Record<SupportedLanguage, Locale> = {
  ca,
  es,
  en: enUS,
};

/**
 * Returns the date-fns locale corresponding to the current i18next language.
 * Falls back to Spanish if the language is not found.
 *
 * @param lang - The i18next language code ('ca', 'es', 'en')
 * @returns The date-fns Locale object
 */
export function getDateFnsLocale(lang: string): Locale {
  const supported = lang as SupportedLanguage;
  return localeMap[supported] || localeMap.es;
}

export { ca, es, enUS };
